import { SObject } from '@/types';

export const SOBJECT_TO_DISPLAY_NAME: Record<SObject, string> = {
  [SObject.AttributeSet]: 'Attribute Set',
  [SObject.Product]: 'Product',
  [SObject.ProductAttribute]: 'Product Attribute',
  [SObject.ProductAttributeSet]: 'Product Attribute Set',
  [SObject.ProductOption]: 'Product Option',
  [SObject.ProductFeature]: 'Product Feature',
  [SObject.ProductRule]: 'Product Rule',
  [SObject.ProductAction]: 'Product Action',
  [SObject.ConfigurationRule]: 'Configuration Rule',
  [SObject.ErrorCondition]: 'Error Condition',
  [SObject.SummaryVariable]: 'Summary Variable',
  [SObject.PriceRule]: 'Price Rule',
  [SObject.QuoteTemplate]: 'Quote Template',
  [SObject.TemplateContent]: 'Template Content',
  [SObject.QuoteTerm]: 'Quote Term',
  [SObject.TermCondition]: 'Term Condition',
  [SObject.CustomAction]: 'Custom Action',
  [SObject.CustomActionCondition]: 'Custom Action Condition',
  [SObject.PriceCondition]: 'Price Condition',
  [SObject.PriceAction]: 'Price Action',
  [SObject.Pricebook]: 'Price Book',
  [SObject.CustomScript]: 'Custom Script',
  [SObject.DiscountCategory]: 'Discount Category',
  [SObject.DiscountSchedule]: 'Discount Schedule',
  [SObject.DiscountTier]: 'Discount Tier',
  [SObject.SearchFilter]: 'Search Filter',
  [SObject.LookupData]: 'Lookup Data',
  [SObject.LookupQuery]: 'Lookup Query',
  [SObject.ConfigurationAttribute]: 'Configuration Attribute',
  [SObject.LineColumn]: 'Line Column',
  [SObject.Localization]: 'Localization',
  [SObject.Cost]: 'Cost',
  [SObject.TemplateSection]: 'Template Section',
  [SObject.BlockPrice]: 'Block Price',
  [SObject.PriceDimension]: 'Price Dimension',
  [SObject.PricebookEntry]: 'Pricebook Entry',
  [SObject.ApprovalRule]: 'Approval Rule',
  [SObject.Approver]: 'Approver',
  [SObject.ApprovalVariable]: 'Approval Variable',
  [SObject.EmailTemplate]: 'Email Template',
  [SObject.ApprovalChain]: 'Approval Chain',
  [SObject.ApprovalCondition]: 'Approval Condition',
  [SObject.TrackedField]: 'Tracked Field',
  [SObject.OptionConstraint]: 'Option Constraint',
  [SObject.GLAccount]: 'GL Account',
  [SObject.GLRule]: 'GL Rule',
  [SObject.GLTreatment]: 'GL Treatment',
  [SObject.LegalEntity]: 'Legal Entity',
  [SObject.TaxRule]: 'Tax Rule',
  [SObject.TaxIntegration]: 'Tax Integration',
  [SObject.TaxTreatment]: 'Tax Treatment',
  [SObject.RevenueDistributionMethod]: 'Revenue Distribution Method',
  [SObject.RevenueRecognitionRule]: 'Revenue Recognition Rule',
  [SObject.RevenueRecognitionTreatement]: 'Revenue Recognition Treatment',
  [SObject.FinanceBook]: 'Finance Book',
  [SObject.FinancePeriod]: 'Finance Period',
  [SObject.PaymentGateway]: 'Payment Gateway',
  [SObject.PaymentScheduler]: 'Payment Scheduler',
  [SObject.BillingRule]: 'Billing Rule',
  [SObject.BillingTreatment]: 'Billing Treatment',
  [SObject.InvoicePlan]: 'Invoice Plan',
  [SObject.InvoiceScheduler]: 'Invoice Scheduler',
};

export const PACKAGE_NAME_TO_SUBSCRIBER_PACKAGE_ID = {
  CPQ_DEPLOYER: '0334N000000AraIQAS',
};

export const SOBJECTS_THAT_REQUIRE_CPQ_DEPLOYER_PACKAGE: Record<
  string,
  boolean
> = {
  [SObject.EmailTemplate]: true,
  [SObject.ApprovalRule]: true,
};
